import "./AboutDetails.css";
import AboutVideo from "./AboutVideo";
import { useTranslation } from "../i18n";
import { renderBrandText } from "../utils/brandText";

function AboutDetails() {
    const { t } = useTranslation();

    return (
        <section className="about-container">
            <div className="about-text">
                <div className="about-intro-heading">
                    <span className="about-section-kicker">{t("about.sectionKicker")}</span>
                    <h2 className="section-title-academy">{renderBrandText(t("about.title"))}</h2>
                </div>
                <div className="about-intro-copy">
                    <p>
                        {renderBrandText(t("about.p1"))}
                    </p>
                    <p>
                        {t("about.p2")}
                    </p>
                    <p>
                        {t("about.p3")}
                    </p>
                    <p>
                        {t("about.p4")}
                    </p>
                    <p>
                        {t("about.p5")}
                    </p>
                    <p>
                        {renderBrandText(t("about.p6"))}
                    </p>
                </div>
            </div>
            <AboutVideo/>
        </section>
    );
}

export default AboutDetails;
